export const BUSINESS_TYPE = {
  SOLE_PROPRIETORSHIP: 'SOLE PROPRIETORSHIP',
  CORPORATION: 'CORPORATION',
  LLC: 'LLC',
  LLP: 'LLP',
  LP: 'LP',
  NON_PROFIT: 'NON-PROFIT',
  PARTNERSHIP: 'PARTNERSHIP',
  PUBLIC_CORPORATION: 'PUBLIC CORPORATION',
  TRUST: 'TRUST',
  UNINCORPORATED_ASSOCIATION: 'UNINCORPORATED ASSOCIATION'
};
